import { Cursors } from '../../constants.js';

class EmptyTool {
    constructor(toolService) {
        this.toolService = toolService;
    }
    start() {
    }
    move() {
    }
    end() {
    }
    tryActivate() {
        return false;
    }
    getCursor() {
        return Cursors.arrow;
    }
}

export { EmptyTool };
